import { cn } from "@omni/utils/styles";

import AutocompleteHeader from "@/components/Search/SearchBar/AutocompleteItem/autocompleteHeader.container";
import { ContentPagesItem } from "@/components/Search/SearchBar/ContentPages/contentPages.item.component";
import { BaseTemplateProps } from "@/components/Search/SearchBar/ResultsPanel/resultsPanel.templates";
import { ContentPagesSourceType } from "@/components/Search/SearchBar/searchBar.types";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type ContentPagesTemplateProps = BaseTemplateProps<ContentPagesSourceType>;

const ContentPagesTemplate = ({
    items,
    autocompleteState,
    autocompleteActions
}: ContentPagesTemplateProps) => {
    const { t } = useGranite();

    if (items.length === 0) return null;

    return (
        <div>
            <AutocompleteHeader
                headerTitle={t("searchBox.panel.contentPages.header.title")}
            />
            <ul className={cn("tw:mb-0")}>
                {items.map((item) => (
                    <li key={item.objectID}>
                        <ContentPagesItem
                            item={item}
                            autocompleteState={autocompleteState}
                            autocompleteActions={autocompleteActions}
                        />
                    </li>
                ))}
            </ul>
        </div>
    );
};

export default ContentPagesTemplate;
